import { useLoaderData } from "react-router-dom";
import { useState } from "react";
import BackNavDetails from "../components/PlanDetails/BackNavDetails.component";
import HeaderDetails from "../components/PlanDetails/HeaderDetail.component";
import ExpandCollapseDetails from "../components/PlanDetails/ExpandCollapseDetails.component";
import { IFullPlanDetail, IFullPlanDetailPPO } from "../interfaces/api";
import HMOAccordionDetails from "../components/PlanDetails/HMOAccordionDetails.component";
import PPOAccordionDetails from "../components/PlanDetails/PPOAccordionDetails.component";
import ScrollToTopOnRouteChange from "../shared/ScrollToTop.function";

interface ILoaderData {
  plan: IFullPlanDetail | IFullPlanDetailPPO;
}

const PlanDetails = () => {
  const { plan: planData } = useLoaderData() as ILoaderData;

  const [allAccordionsOpen, setAllAccordionsOpen] = useState<boolean>(false);
  const [anyAccordionOpen, setAnyAccordionOpen] = useState<boolean>(false);

  const donwloadLink =
    "https://www.alignmenthealthplan.com/members/member-forms-resources";

  const groupData =
    planData?.PlanDetails?.[0].company[0].healthPlan[0].pbp[0].group;

  const uniquePbpBenefitGroups = new Set();

  groupData &&
    groupData.forEach((group) => {
      const pbpBenefitGroup = group.pbpBenefitGroup;
      if (pbpBenefitGroup) {
        uniquePbpBenefitGroups.add(pbpBenefitGroup);
      }
    });

  const scrollTo = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleAllAccordions = (isOpen: boolean) => {
    setAllAccordionsOpen(isOpen);
  };

  const goDownload = (e: any) => {
    e.preventDefault();
    window.open(donwloadLink, "_blank");
  };

  if (!planData) {
    return null;
  }

  return (
    <div>
      <ScrollToTopOnRouteChange />
      <BackNavDetails county={planData.PlanDetails} />
      <HeaderDetails data={planData.PlanDetails} />
      <div className="grid-container">
        <ExpandCollapseDetails
          toggleAllAccordions={toggleAllAccordions}
          allAccordionsOpen={allAccordionsOpen}
          anyAccordionOpen={anyAccordionOpen}
        />
        {planData.PlanDetails[0].company[0].healthPlan[0].lob === "HMO" ? (
          <HMOAccordionDetails
            data={planData as IFullPlanDetail}
            allAccordionsOpen={allAccordionsOpen}
            setAnyAccordionOpen={setAnyAccordionOpen}
          />
        ) : (
          <PPOAccordionDetails
            data={planData as IFullPlanDetailPPO}
            allAccordionsOpen={allAccordionsOpen}
            setAnyAccordionOpen={setAnyAccordionOpen}
          />
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            onClick={scrollTo}
            className="primary-color"
            style={{
              cursor: "pointer",
              fontSize: 18,
              fontWeight: 500,
            }}
          >
            ^ Back to top
          </button>
        </div>
        <div
          className="hide-for-small-only"
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: 23,
            paddingBottom: 73,
          }}
        >
          <button type="button" className="button" onClick={goDownload}>
            Download Summary of Benefits
          </button>
        </div>
        <div
          className="show-for-small-only"
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "25px 0px",
            width: "100%",
            flex: 1,
          }}
        >
          <button
            type="button"
            className="button"
            style={{
              width: "100%",
            }}
            onClick={goDownload}
          >
            Download Summary of Benefits
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanDetails;
